import axios from "axios";
import { saveApiToken, clearApiToken, TEMPO_LIMITE_MS } from "./apiClient";
import { adapterMockSobDemanda, mockApiAtivo } from "./mockApiFlag";

const loginClient = axios.create({ baseURL: "/api/v1", timeout: TEMPO_LIMITE_MS });

if (mockApiAtivo) {
  loginClient.defaults.adapter = adapterMockSobDemanda();
}

export interface UsuarioApi {
  login: string;
  nome: string;
  codpessoa: number;
  codpessoapai: number;
  interno: boolean;
}

export interface LoginApiResponse {
  token: string;
  expiraEm: string | number;
  usuario: UsuarioApi;
}

export const autenticarApi = async (usuario: string, senha: string): Promise<LoginApiResponse> => {
  clearApiToken();
  const { data } = await loginClient.post<LoginApiResponse>("/auth/login", { usuario, senha });
  saveApiToken(data.token, data.expiraEm);
  return data;
};

export const autenticarApiPorTicket = async (ticket: string): Promise<LoginApiResponse> => {
  clearApiToken();
  const { data } = await loginClient.post<LoginApiResponse>("/auth/handoff", { ticket });
  saveApiToken(data.token, data.expiraEm);
  return data;
};

export const logoutApi = () => clearApiToken();
